export default class PedidoTag {
	constructor(
		pedido_id='',
		tag_id=''
	){
		this.pedido_id = pedido_id;
		this.tag_id = tag_id;
	}
}